import React, {Component} from 'react'
import { connect } from 'react-redux'
import {Auth, AppRouter} from './'
import {Loader} from './../components'


import { 
  fetchUser as SFetchUser,
  checkConnect as SCheckConnect,
} from './../store/actions/Session'
import { withRouter } from 'react-router'
import { compose } from 'recompose'
import { initGA } from './../services/ApiController'

class AuthGate extends Component {
  state = {
    loaded: false,
    transition: false,
  }

  componentDidMount() {
    this.getUser()
  }

  getUser() {
    this.props.fetchUser().then(() => {
      // this.props.fetchChallenge()
      initGA(this.props.username)
      this.setState({ transition: true }, () => {
        this.transitionTimeout = setTimeout(() => {
          this.setState({ loaded: true })
        }, 400)
      })
    }).catch((err) => {
      console.log('Something wrong')
    })

  }

  componentWillReceiveProps({location}){
    if (location.pathname !== this.props.location.pathname) {
      this.props.isConnected()
    }
  }

  componentWillUnmount() {
    // clearTimeout(this.transitionTimeout)
  }

  render() {
    const { transition, loaded } = this.state
    const { username } = this.props
    return (
      <div className="app">
        {
          !loaded && (
            <Loader transition={transition} />
          )
        }
        {
          Boolean(username) ? <AppRouter /> : <Auth />
        }
      </div>
    )
  }
}

const enhance = compose(
  withRouter,
  connect(
    ({ Session }) => ({
      username: Session.username,
      connectedAt: Session.initAt,
    }),
    dispatch => ({
      fetchUser: () => dispatch(SFetchUser()),
      isConnected: () => dispatch(SCheckConnect())
    })
  )
)

export default enhance(AuthGate)


// WEBPACK FOOTER //
// ./src/scenes/AuthGate.js